/*http配置*/
import axios from 'axios'
import router from '../router'
import ifconfig from './ifConfig'
import ip from './ip'
import store from '../store/store'
import * as types from '../store/types'
import * as cookie from '../util/util'
// axios配置
const instance = axios.create({
    timeout: 180000,
    headers: Object.assign({}, ifconfig.headers)
});

// http request拦截器
instance.interceptors.request.use(
    config => {
        if (store.state.token) {  // 判断是否存在token，如果存在的话，则每个http header都加上token
            config.headers.token = `${store.state.token}`;
        }
        return config
    },
    err => {
        return Promise.reject(err);
    }
)
// http response 拦截器
instance.interceptors.response.use(
    response => {
        if (response.data.status == 119 || response.data.message === 'token???') { 
            // this.$store.commit('del_token') //可能是token过期，清除它
            localStorage.removeItem('token');
            router.replace({
                path: '/',
                query: {
                    redirect: router.currentRoute.fullPath
                }
            })
        }
        return response
    },error => {
        if (error.response) {
            switch (error.response.status) {
                case 119:
                this.$store.commit('del_token') //可能是token过期，清除它
                // localStorage.removeItem('token'); 
                router.replace({
                    path: '/',
                    query: {
                        redirect: router.currentRoute.fullPath
                    }
                })
            }
        }
        return Promise.reject(error.response.data)
    }
)
export default instance


// WEBPACK FOOTER //
// ./src/config/http.js